import { Button } from '@cimpress/react-components';
import React from 'react';
import { Truck } from '../../models/truck';

interface Props {
  truck: Truck;
  hide: () => void;
  submit: (truck: Truck) => void;
}

const showDeleteTruckWarningComponent = ({ truck, hide, submit } : Props) => {
  const handleDelete = () => {
    submit(truck);
    hide();
  };
  return (
    <div>
      <h3 style={{ marginBottom: '30px' }}>
        Are you sure you want to delete the truck?
      </h3>
      <Button style={{ marginRight: '10px' }} onClick={handleDelete}>
        Yes
      </Button>
      <Button onClick={hide}>
        No
      </Button>
    </div>
  );
};

export default showDeleteTruckWarningComponent;
